import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      position="top-right"
      expand
      richColors
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:border group-[.toaster]:border-white/10 group-[.toaster]:bg-[linear-gradient(180deg,rgba(23,27,40,0.98),rgba(13,16,25,0.98))] group-[.toaster]:text-foreground group-[.toaster]:shadow-[0_20px_60px_rgba(0,0,0,0.35)] group-[.toaster]:backdrop-blur-xl',
          description: 'group-[.toast]:text-white/68',
          actionButton:
            'group-[.toast]:border group-[.toast]:border-white/10 group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:border group-[.toast]:border-white/10 group-[.toast]:bg-white/[0.05] group-[.toast]:text-white/75',
          closeButton:
            'group-[.toast]:border group-[.toast]:border-white/10 group-[.toast]:bg-white/[0.06] group-[.toast]:text-white/55 group-[.toast]:hover:bg-white/[0.12] group-[.toast]:hover:text-white',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
